// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__21Dot","col":"styles_col__s7vWg","fulfillmentStatus":"styles_fulfillmentStatus__1L_yl","emailCol":"styles_emailCol__28h71"};